module.exports = __webpack_public_path__ + "static/media/faces-full.7c735021.png";